var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-sheet',{attrs:{"flat":""}},[(_vm.loading)?_c('loading'):_c('div',[_c('v-sheet',[_c('export',{attrs:{"columns":_vm.headers,"rows":_vm.items,"name":"dma-data","text":"Export full dataset"}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }